import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurStoryAndMethod from "./sections/OurStoryAndMethod";
import OurTeam from "./sections/OurTeam";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Hero />
      <OurStoryAndMethod />
      <OurTeam />
      <Footer />
    </div>;
}